export default "__VITE_ASSET__b61abb26__"